<template>
  <div style="width: 100%">
    <div class="echarts" ref="pl"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { numMul, numSub, numAdd } from "@/utils";

export default {
  props: {
    data: Array,
  },
  computed: {
    up_color() {
      return {
        color1:'#26CE3D',
        color2:'#fff',
      };
    },
    down_color() {
      return {
        color1:'#CE2626',
        color2:'#ffff',
      };
    },
  },
  mounted() {
    var level;
    // if (this.data.length) {
    //   level = this.data[this.data.length - 1][1];
    //   // console.log(level);
    // }

    var myChart = echarts.init(this.$refs.pl);
    var option = {
      grid: {
        left: "1%",
        right: "1%",
        top: "10%",
        bottom: "10%",
      },
      tooltip: {
        trigger: "axis", // 触发类型
        confine: true, //将 tooltip 框限制在图表的区域内。
        textStyle: {
          fontSize: 12,
          color: "#E7EEF8",
        },
        backgroundColor: "#8EA4BD", //设置背景图片 rgba格式
        borderColor: "#2D3D5C",
        formatter(obj) {
          var value = obj[0].data;
          return (
            "<div>" +
            value.date+
            "<br />" +
            "<div style=''>" +
            "PL :  $" +
            value.return_rate +
            "</div>" +
            "</div>"
          );
          // return (
          //   "<div>" +
          //   value[0].substr(0, 10) +
          //   "<br />" +
          //   "<div style=''>" +
          //   "PL :  $" +
          //   value[1] +
          //   "</div>" +
          //   "</div>"
          // );
        },
      },
      xAxis: {
        type: "category",
        axisTick: {
          show: false, //隐藏坐标轴的刻度
        },
        axisLine: {
          // X轴及其文字颜色
          lineStyle: {
            color: this.up_color.color2,
            width: 1,
            type: "dashed",
          },
        },
        // show: false,
      },
      yAxis: {
        show: false,
          min: function (value) {
            // return parseInt(value.min -100);
            if (value.min >= 0) {
              if (value.min === value.max) {
                return parseFloat(numMul(value.max, 0.9)).toFixed(2);
              }
              return parseFloat(
                numSub(value.min, numMul(numSub(value.max, value.min), 0.1))
              ).toFixed(2);
            } else if (value.min < 0 && value.max >= 0) {
              return parseFloat(
                numSub(value.min, numMul(numSub(value.max, value.min), 0.1))
              ).toFixed(2);
            } else {
              if (value.min === value.max) {
                return parseFloat(numMul(value.max, 1.1)).toFixed(2);
              }
              return parseFloat(
                numAdd(value.min, numMul(numSub(value.min, value.max), 0.1))
              ).toFixed(2);
            }
          },
          max: function (value) {
            if (value.min >= 0) {
              if (value.min === value.max) {
                return parseFloat(numMul(value.max, 1.1)).toFixed(2);
              }
              return parseFloat(
                numAdd(value.max, numMul(numSub(value.max, value.min), 0.1))
              ).toFixed(2);
            } else if (value.min < 0 && value.max >= 0) {
              return parseFloat(
                numAdd(value.max, numMul(numSub(value.max, value.min), 0.1))
              ).toFixed(2);
            } else {
              if (value.min === value.max) {
                return parseFloat(numMul(value.max, 0.9)).toFixed(2);
              }
              return parseFloat(
                numSub(value.max, numMul(numSub(value.min, value.max), 0.1))
              ).toFixed(2);
            }
          },
      },
      dataset: {
        source: this.data,
      },
      series: [
        {
          type: "line",
          label: {
            show: false,
          },
          smooth: true,
          symbol: "none",
          color: this.up_color.color1,

          lineStyle: {
            width: 1, //线条宽度

          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: this.up_color.color1, // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: this.up_color.color2, // 100% 处的颜色
                  // color: "rgba(255,000,000,0.08)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
            // opacity: 0.3,
            origin: "start",
          },
        },
      ],
    };
    var option2 = {
      grid: {
        left: "1%",
        right: "1%",
        top: "10%",
        bottom: "10%",
      },
      tooltip: {
        trigger: "axis", // 触发类型
        confine: true, //将 tooltip 框限制在图表的区域内。
        textStyle: {
          fontSize: 12,
          color: "#E7EEF8",
        },
        backgroundColor: "#8EA4BD", //设置背景图片 rgba格式
        borderColor: "#2D3D5C",
        formatter(obj) {
          
          
          var value = obj[0].value;
          // return (
          //   "<div>" +
          //   value[0].substr(0, 10) +
          //   "<br />" +
          //   "<div style=''>" +
          //   "PL :  $" +
          //   value[1] +
          //   "</div>" +
          //   "</div>"
          // );
          return (
            "<div>" +
            value[0]+
            "<br />" +
            "<div style=''>" +
            "PL :  $" +
            value[1] +
            "</div>" +
            "</div>"
          );
        },
      },
      xAxis: {
        type: "category",
        axisTick: {
          show: false, //隐藏坐标轴的刻度
        },
        axisLine: {
          // X轴及其文字颜色
          lineStyle: {
            color: this.down_color.color2,
            width: 1,
            type: "dashed",
          },
        },
        // show: false,
      },
      yAxis: {
        show: false,
      },
      dataset: {
        // dimensions: ["date", "pl"],
        source: this.data,
      },
      series: [
        {
          type: "line",
          label: {
            show: false,
          },
          smooth: true,
          symbol: "none",
          color: this.down_color.color1,

          lineStyle: {
            width: 1, //线条宽度
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: this.down_color.color1, // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: this.down_color.color2, // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
            // opacity: 0.3,
            origin: "start",
          },
        },
      ],
    };
    // if (level > 0) {
      myChart.setOption(option);
    // } else {
    //   myChart.setOption(option2);
    // }
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
};
</script>
<style lang="css" scoped>
.echarts {
  width: 100%;
  height: 70px;
}
</style>